export const models = [
  {
    name: 'Fighter',
    price: 0,
    maxSpeed: 245,
    weight: 800,
    src: '/models/2d/1.png',
    modelPath: '/models/3d/space_fighter_v2.glb',
    scale: 0.13,
    position: [0, 13, -37],
    target3: -15
  },  
  {
    name: 'Cabir',
    price: 10000,
    maxSpeed: 321,
    weight: 800,
    src: '/models/2d/2.png',
    modelPath: '/models/3d/carrier_ship.glb',
    scale: 20,
    position: [0, 20, -40],
    target3: -15
  },
  {
    name: 'Spalink',
    price: 10000,
    maxSpeed: 192,
    weight: 800,
    src: '/models/2d/3.png',
    modelPath: '/models/3d/space_ship.glb',
    scale: 3,
    position: [0, 20, -40],
    target3: -15
  } 
];